// extracted by mini-css-extract-plugin
module.exports = {"WithNumberCard":"brightway-by-the-numbers_WithNumberCard__aAzuY"};